<!-- Only show if config loaded successfully -->
<div class="agent-landing-content" *ngIf="hasConfig && !isLoading">
  <div class="agent-info-block">
    <div class="agent-header">
      <div class="agent-icon-wrapper" *ngIf="agentIcon">
        <img [src]="agentIcon" [alt]="agentTitle" class="agent-icon">
      </div>
      <div class="agent-text-content">
        <h1 class="agent-title">{{ (agentTitle ||"")| translate }}</h1>
        <div class="agent-description">{{ (personalizedIntro||"")| translate }}</div>
      </div>
    </div>
  </div>
</div>

<!-- ✅ Fallback: Show loading or empty state if config not available -->
<div class="agent-landing-loading" *ngIf="isLoading">
  <div class="loading-spinner">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <p>{{'LOADING_AGENT_INFORMATION_MESSAGE'| translate}}</p>
  </div>
</div>

<div class="agent-landing-error" *ngIf="!hasConfig && !isLoading">
  <div class="error-message">
    <i class="fa-solid fa-exclamation-triangle"></i>
    <p>{{'AGENT_CONFIGURATION_NOT_AVAILABLE_MESSAGE'| translate}}</p>
  </div>
</div>

